

/// <reference path="ContainerUnits.ts" />

// Generated class ContainerProduct_ManagedObject

class ContainerProduct_ManagedObject extends ContainerUnits
{
}
